import { render, staticRenderFns } from "./MpOrientation.vue?vue&type=template&id=b054a418&scoped=true&"
import script from "./MpOrientation.vue?vue&type=script&lang=js&"
export * from "./MpOrientation.vue?vue&type=script&lang=js&"
import style0 from "./MpOrientation.vue?vue&type=style&index=0&id=b054a418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b054a418",
  null
  
)

export default component.exports